var _defs, _path, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTempo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #171954;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #171954;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.91,10.85c-14.69,0-26.65,11.95-26.65,26.65s11.95,26.65,26.65,26.65,26.65-11.95,26.65-26.65-11.95-26.65-26.65-26.65Zm0,48.91c-12.28,0-22.26-9.99-22.26-22.26s9.99-22.26,22.26-22.26,22.26,9.99,22.26,22.26-9.99,22.26-22.26,22.26Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "38.91 20.95 38.91 37.55 47.11 29.25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTempo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TEMPO.d60f1edf0ef548ff041f37b94dc496b1.svg";